import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((_) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  modalTitle: {
    fontSize: 20,
    fontWeight: "bold",
  },
  modalBody: {
    width: "50vw",
    height: "65vh",
    padding: 10,
    border: "none",
  },
  mapButton: {
    height: 41.625,
    textTransform: "none",
  },
}));
